if (!customElements.get('ls-products-slider')) {
  const BaseSlider = customElements.get('slider-component');
  if (BaseSlider) {
    customElements.define('ls-products-slider', class extends BaseSlider {
      initPages() {
        this.sliderItemsToShow = Array.from(this.sliderItems).filter(item => item.clientWidth > 0);
        if (this.sliderItemsToShow.length < 2) return;
        const first = this.sliderItemsToShow[0];
        this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - first.offsetLeft;
        const gap = this.sliderItemOffset - first.clientWidth;
        this.slidesPerPage = Math.max(1, Math.floor((this.slider.clientWidth + gap + 1) / this.sliderItemOffset));
        this.totalPages = Math.max(1, this.sliderItemsToShow.length - this.slidesPerPage + 1);
        this.update();
      }
    });
  }
}
